var _defs, _path, _path2, _g, _text, _text2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAog058Xxx(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    width: 779.53,
    height: 311.81,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs411"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect408",
    fill: "none",
    d: "M204.8 55.99h779.53v226.77H204.8z"
  })), /*#__PURE__*/React.createElement("style", {
    id: "style406"
  }, ".cls-1,.cls-2{fill:#fff}.cls-3{letter-spacing:0}.cls-4{letter-spacing:-.03em}.cls-9{letter-spacing:-.04em}.cls-10{fill:#231f20}.cls-2{font-family:Arial-Black,Arial;font-size:28.35px;font-weight:800}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "rect413",
    fill: "#ed1c24",
    d: "M0 0h779.53v311.81H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "rect415",
    fill: "#fff200",
    d: "M0 42.52h779.53v226.77H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath)",
    id: "g459",
    transform: "translate(-204.8 -13.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g421"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    transform: "rotate(-45 1019.765 169.37)",
    id: "rect417",
    d: "M998.51-43.23h42.52v425.2h-42.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1155.06 338.74l-2-2L850.39 34.07 884.47 0l2 2 302.66 302.66-34.08 34.07zM858.41 34.07l296.65 296.65 26.06-26.06L884.47 8.02l-26.06 26.06z",
    id: "path419"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g427"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    transform: "rotate(-45 594.566 169.373)",
    id: "rect423",
    d: "M573.31-43.23h42.52v425.2h-42.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M729.87 338.74l-2-2L425.2 34.07 459.27 0l304.67 304.67zM433.21 34.07l296.65 296.65 26.06-26.06L459.27 8.02l-26.06 26.06z",
    id: "path425"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g433"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    transform: "rotate(-45 452.835 169.37)",
    id: "rect429",
    d: "M431.58-43.23h42.52v425.2h-42.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M588.13 338.74l-2-2L283.46 34.07 317.54 0l304.67 304.67-34.07 34.07zM291.48 34.07l296.65 296.65 26.06-26.06L317.54 8.02l-26.06 26.06z",
    id: "path431"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g439"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    transform: "rotate(-45 311.104 169.367)",
    id: "rect435",
    d: "M289.84-43.23h42.52v425.2h-42.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M446.4 338.74l-2-2L141.73 34.07 175.81 0l304.67 304.67-34.07 34.07zM149.75 34.07L446.4 330.72l26.06-26.06L175.81 8.02l-26.06 26.06z",
    id: "path437"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g445"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    transform: "rotate(-45 169.368 169.376)",
    id: "rect441",
    d: "M148.11-43.23h42.52v425.2h-42.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M304.67 338.74l-2-2L0 34.07 34.07 0l304.67 304.67zM8.02 34.07l296.65 296.65 26.06-26.06L34.07 8.02 8.01 34.08z",
    id: "path443"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g451"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    transform: "rotate(-45 736.298 169.376)",
    id: "rect447",
    d: "M715.04-43.23h42.52v425.2h-42.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M871.6 338.74l-2-2L566.93 34.07 601 0l2 2 302.66 302.66-34.08 34.07zM574.95 34.07L871.6 330.72l26.06-26.06L601 8.02l-26.06 26.06z",
    id: "path449"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g457"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    transform: "rotate(-45 878.034 169.366)",
    id: "rect453",
    d: "M856.77-43.23h42.52v425.2h-42.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1013.33 338.74l-2-2L708.66 34.07 742.74 0l2 2 302.66 302.66-34.08 34.07zM716.68 34.07l296.65 296.65 26.06-26.06L742.74 8.02l-26.06 26.06z",
    id: "path455"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    id: "text471",
    x: 15.26,
    y: 301.19
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 15.26,
    y: 301.19,
    id: "tspan461"
  }, "FORKLIFT TRAFFIC -"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 346.02,
    y: 301.19,
    id: "tspan463"
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    x: 366.85,
    y: 301.19,
    id: "tspan465"
  }, "ANGER"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 488.1,
    y: 301.19,
    id: "tspan467"
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 507.6,
    y: 301.19,
    id: "tspan469"
  }, "O PEDESTRIANS"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "scale(-1)",
    id: "text483",
    x: -764.28,
    y: -10.61
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -764.28,
    y: -10.61,
    id: "tspan473"
  }, "FORKLIFT TRAFFIC -"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: -433.52,
    y: -10.61,
    id: "tspan475"
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    x: -412.69,
    y: -10.61,
    id: "tspan477"
  }, "ANGER"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: -291.44,
    y: -10.61,
    id: "tspan479"
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: -271.94,
    y: -10.61,
    id: "tspan481"
  }, "O PEDESTRIANS"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAog058Xxx);
export default __webpack_public_path__ + "static/media/AOG058XXX.ee7084cb3d5efd38ee8839e72a6bf495.svg";
export { ForwardRef as ReactComponent };